import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-custom col-lg-6 mt-5" }
const _hoisted_2 = { class: "p-field" }
const _hoisted_3 = {
  class: "p-field-label",
  for: "name"
}
const _hoisted_4 = { class: "p-field-radiobutton mt-3" }
const _hoisted_5 = { for: "gtLights" }
const _hoisted_6 = { class: "p-field-radiobutton" }
const _hoisted_7 = { for: "gtShutters" }
const _hoisted_8 = { class: "p-field mt-5" }
const _hoisted_9 = {
  class: "p-field-label",
  for: "name"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_InputText = _resolveComponent("InputText")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("AppResource.Groups")), 1)
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_RadioButton, {
        id: "gtLights",
        name: "groupType",
        onChange: _ctx.computeGroupName,
        value: _ctx.RoomObjectType.Light,
        modelValue: _ctx.commandGroup.roomObjectType,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.commandGroup.roomObjectType = $event))
      }, null, 8, ["onChange", "value", "modelValue"]),
      _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("AppResource.Light")), 1)
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_RadioButton, {
        id: "gtShutters",
        name: "groupType",
        onChange: _ctx.computeGroupName,
        value: _ctx.RoomObjectType.Shutter,
        modelValue: _ctx.commandGroup.roomObjectType,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.commandGroup.roomObjectType = $event))
      }, null, 8, ["onChange", "value", "modelValue"]),
      _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("AppResource.Shutter")), 1)
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("AppResource.Name")), 1),
      _createVNode(_component_InputText, {
        id: "name",
        type: "text",
        class: ["w-100", { 'input-error': !_ctx.isValidName }],
        modelValue: _ctx.commandGroup.name,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.commandGroup.name = $event))
      }, null, 8, ["modelValue", "class"]),
      _createVNode("label", {
        if: !_ctx.isValidName,
        for: "name",
        class: "fs-13 label-error"
      }, _toDisplayString(_ctx.invalidNameReason), 9, ["if"])
    ])
  ]))
}